import { Action } from 'redux'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'

export default function(version) {
  return {
    type: SynchronizeActions.ToggleNewVersionModal,
    version,
  }
}

export interface IToggleNewVersionModal
  extends Action<SynchronizeActions.ToggleNewVersionModal> {
  version: string
}
